import React, { Component } from 'react';
import {Row, Col, Button} from 'react-bootstrap';
import _ from 'lodash';
import Picky from 'react-picky';
import 'react-picky/dist/picky.css';
import DatePicker from "react-datepicker";
import moment from "moment";
import { addDays } from 'date-fns';
import VarianceStatus from './varinacestatus';

 export default class CalibrationStatus extends Component { 
	constructor(props){
    super(props)
    this.state= {
      selectedregionName:[],
      selectedcenterName:[],
      selectedclientName:[],
      selectedprocessName:[],
      saveClicked:false,
      GenerateReport:false,
      toggleA:true
    }
   }
  componentWillMount = () => {  
    const{inventory} = this.props;
    if(!_.isEmpty(inventory)){      
      let regionNames = _.filter(inventory);
      this.setState({selectedregionName:regionNames[0]})
    }    
  }
  regionNames = () => {
    const{inventory} = this.props;
    if(!_.isEmpty(inventory)){
     let regionNames = _.filter(inventory);
      return regionNames;
    }    
  }
  centerNames = () => {
    const{selectedregionName} = this.state;
    if(!_.isEmpty(selectedregionName)){
      let centerName = selectedregionName.userCenters
      return centerName;
    }
    
  }
  clientNames = () =>{
    const{selectedcenterName} = this.state;
    let clientName = []
    if(!_.isEmpty(selectedcenterName)){
        clientName = _.filter(selectedcenterName.userClients);
        clientName = _.uniqBy(clientName, 'inventoryClientId');
    }
    return clientName;
  }
  processNames = () => {
    const{selectedclientName} = this.state;
    let processName=[];
    if(!_.isEmpty(selectedclientName)){
            processName = (selectedclientName.userProcesses)
            processName = _.uniqBy(processName, 'inventoryProcessId');
      }
    return processName;
  }
  
  
  handleSelect = (e) => {
    this.setState({selectedregionName: e});
    if(!_.isEqual(this.state.selectedregionName, e)){
      this.setState({selectedcenterName:[], selectedclientName:[], selectedprocessName:[], GenerateReport:false})
    }
  }
  handleSelectCenter = (e) => {
    this.setState({selectedcenterName: e});
    if(!_.isEqual(this.state.selectedcenterName, e)){
      this.setState({selectedclientName:[], selectedprocessName:[], GenerateReport:false})
    }
  }
  handleSelectClient = (e) => {
    this.setState({selectedclientName: e});
    if(!_.isEqual(this.state.selectedclientName, e)){
      this.setState({selectedprocessName:[], GenerateReport:false})
    }
  }
  handleSelectProcess = (e) => {
    this.setState({selectedprocessName: e});  
    if(!_.isEqual(this.state.selectedprocessName, e)){
      this.setState({GenerateReport:false})
    }
  }
  handleChangeStart = (date) => {
    //date.setMinutes( date.getMinutes() + date.getTimezoneOffset() );
   // const formattedDate = date.getDate()+'/'+[date.getMonth()+1]+'/'+date.getFullYear();
    this.setState({startDate: date});
    //date.setMinutes( date.getMinutes() + date.getTimezoneOffset() )
  }
  handleChangeEnd = (e) => {
    this.setState({endDate: e});
  }
  validateInput = () =>{
    const {selectedregionName, selectedcenterName, selectedclientName, selectedprocessName, startDate, endDate} = this.state
    if(!_.isEmpty(selectedregionName) && !_.isEmpty(selectedcenterName) && !_.isEmpty(selectedclientName) &&
    !_.isEmpty(selectedprocessName)  && typeof startDate !== "undefined" && typeof endDate !== "undefined"){
      return true
    }
  }
  generateReport = () => {
    const {selectedregionName, selectedcenterName, selectedclientName, selectedprocessName, startDate, endDate } = this.state
    let obj = {
       "region":selectedregionName.inventoryRegionName,
       "center":selectedcenterName.inventoryCenterName,
       "client":selectedclientName.inventoryClientName,
       "process":selectedprocessName.inventoryProcessName,
       "regionId":selectedregionName.inventoryRegionId,
       "centerId":selectedcenterName.inventoryCenterId,
       "clientId":selectedclientName.inventoryClientId,
       "processId":selectedprocessName.inventoryProcessId,
      "startDate":moment(startDate).format('YYYY-MM-DD'), 
      "endDate":moment(endDate).format('YYYY-MM-DD')
      }
    this.props.action.TokenValidation()    
    this.props.action.getCaLibrtionStatus(obj)   
    this.setState({GenerateReport:true})
  }
 
  handleToggle = () =>{
    this.setState((prevState) =>{
      return {toggleA: !prevState.toggleA};
    })
  }
	render(){    
    const {GenerateReport, toggleA} = this.state; 		
		return(
     <div>
      <h6><i class="fas fa-caret-right"/><b>&nbsp;STATUS CRITERIA</b></h6>  
      <Row className="marginBottom">  
        <Col>
        <label><b>REGION NAME<span className="RedColoring"> *</span></b></label><br/>
        <Picky keepOpen={false}
          value={this.state.selectedregionName}
          options={this.regionNames()}
          onChange={this.handleSelect}
          open={false}
          valueKey="inventoryRegionName"
          labelKey="inventoryRegionName"
          multiple={false}
          includeSelectAll={false}
          includeFilter={false}
          placeholder='Select Region'
          dropdownHeight={600}
        />
        </Col>
        <Col>
        <label><b>CENTER NAME<span className="RedColoring"> *</span></b></label>
        <Picky keepOpen={false}
          value={this.state.selectedcenterName}
          options={this.centerNames()}
          onChange={this.handleSelectCenter}
          open={false}
          valueKey="inventoryCenterName"
          labelKey="inventoryCenterName"
          multiple={false}
          includeSelectAll={true}
          includeFilter={false}
          placeholder='Select Center'
          dropdownHeight={600}
        />
        </Col>
        <Col>
        <label><b>CLIENT NAME<span className="RedColoring"> *</span></b></label>
        <Picky keepOpen={false}
        value={this.state.selectedclientName}
        options={this.clientNames()}
        onChange={this.handleSelectClient}
        open={false}
        valueKey="inventoryClientName"
        labelKey="inventoryClientName"
        multiple={false}
        includeSelectAll={true}
        includeFilter={false}
        placeholder='Select Client'
        dropdownHeight={600}
      />
      </Col>
        <Col>
        <label><b>PROCESS NAME<span className="RedColoring"> *</span></b></label>
        <Picky keepOpen={false}
        value={this.state.selectedprocessName}
        options={this.processNames()}
        onChange={this.handleSelectProcess}
        open={false}
        valueKey="inventoryProcessName"
        labelKey="inventoryProcessName"
        multiple={false}
        includeSelectAll={true}
        includeFilter={false}
        placeholder='Select Process'
        dropdownHeight={600}
      />
      </Col>
        <Col>
        <label><b>FROM DATE<span className="RedColoring"> *</span></b></label>
        <DatePicker
            selected={this.state.startDate}
            className='myDatePicker'
            selectsStart
            showMonthDropdown
            startDate={this.state.startDate}
            endDate={this.state.endDate}
            onChange={this.handleChangeStart}
            dateFormat="dd/MM/yyyy"          
            maxDate={new Date()}
            placeholderText="Start Date"          
          />
          </Col>
        <Col>
        <label><b>TO DATE<span className="RedColoring"> *</span></b></label>
        <DatePicker
          selected={this.state.endDate}
          selectsEnd
          startDate={this.state.startDate}
          endDate={this.state.endDate}
          onChange={this.handleChangeEnd}
          minDate={this.state.startDate}
          dateFormat="dd/MM/yyyy"
          placeholderText="End Date"
          maxDate={addDays(this.state.startDate, 14)}
          popperModifiers={{
            preventOverflow: {
              enabled: true,
              escapeWithReference: false, 
              boundariesElement: 'viewport'
            }
          }}
          />    
       </Col> 
     </Row> 
      <Button className='buttonwidth alignInline alignRight' disabled={!this.validateInput()}
      onClick={this.generateReport}>Generate Status</Button>&nbsp; 
      {((GenerateReport === true) && !_.isEmpty(this.props.calibrationStatus)) ?
      <div>
        <VarianceStatus  reportData={this.props.calibrationStatus} /> 
      </div>
      : null}     
    </div>)
	}


}

